export enum Status {
  Loading,
  Loaded,
  Sending,
  Success,
  Error
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/enums/status.ts